import { getApiRegionSlug } from "./api-region-slug";
import { applyRegionToUrlTemplate } from "./region-url-template";

function readWindowString(key: string): string {
  if (typeof window === "undefined") {
    return "";
  }
  const v = (window as unknown as Record<string, string | undefined>)[key];
  return typeof v === "string" && v.length > 0 ? v : "";
}

/** Env URL template with `{region}` resolved from `getApiRegionSlug()` (KV on boot). */
export function resolveRegionalApiUrl(viteProp: string): string {
  const raw = (import.meta.env as Record<string, string | undefined>)[
    viteProp
  ];
  return applyRegionToUrlTemplate(raw, getApiRegionSlug()) || "";
}

/** Non-regional URL: prefer `window`, else raw `import.meta.env`. */
export function resolvePlainApiUrl(
  windowKey: string,
  viteProp: string,
): string {
  const w = readWindowString(windowKey);
  if (w) {
    return w;
  }
  return (
    (import.meta.env as Record<string, string | undefined>)[viteProp] || ""
  );
}

export function defineLazyUrlProperties<T extends Record<string, () => string>>(
  definitions: T,
): { [K in keyof T]: string } {
  const result = {} as { [K in keyof T]: string };
  for (const key of Object.keys(definitions) as (keyof T)[]) {
    Object.defineProperty(result, key, {
      get: () => definitions[key](),
      enumerable: true,
      configurable: true,
    });
  }
  return result;
}

function createLazyString(getter: () => string): string {
  const box = {
    [Symbol.toPrimitive]() {
      return getter();
    },
    toString() {
      return getter();
    },
    valueOf() {
      return getter();
    },
  };
  return box as unknown as string;
}

/** Gorelo-managed app mail host: prefer `window.appmailDomain`, else USW env default. */
export function resolveAppmailDomain(): string {
  const w = readWindowString("appmailDomain");
  if (w) {
    return w;
  }
  const env = import.meta.env as Record<string, string | undefined>;
  return env.VITE_appmailDomain_usw || "appmail.gorelo.io";
}

export const appmailDomain = createLazyString(resolveAppmailDomain);
